"use client";
import React, { useState } from "react";
import { SecondaryOuter } from "../../../components/molecules";
import ProfileCard from "../../../components/ProfileCard";
import Image from "next/image";
import { flattenAttributes, getImageUrlNew } from "../../../lib/util";
// import reviewIcon from "../../../../public/reviewIcon.svg";
import reviewIcon from "../../../../public/siteLogo.svg";
import { useDictionary } from "../../../context/dictionaryProvider";
import { getTestimonials } from "../../../actions/singles";
import { useParams } from "next/navigation";

const RoundShape = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width=""
      height="101"
      viewBox="0 0 149 101"
      fill="none"
      className="absolute right-0 -top-[5px] 2xl:top-0 z-[20] w-[130px] 2xl:w-[149px]"
    >
      <path
        d="M29.5323 14.2938C29.5323 -3.83929 9.947 -1.61205 0.5 -2H150.5V101C150.5 92.0217 143.654 86.3306 137.579 83.3567C133.915 81.5632 129.774 81.2147 125.695 81.2147H61.5323C43.8591 81.2147 29.5323 66.8878 29.5323 49.2147V14.2938Z"
        fill="white"
      />
    </svg>
  );
};

const TestimonialGrid = ({ initialData }) => {
  const dict = useDictionary();
  const params = useParams();
  const [pagination, setPagination] = useState({
    ...initialData?.meta?.pagination,
    start:
      initialData?.meta?.pagination?.start +
      initialData?.meta?.pagination?.limit,
  });
  const [testimonials, setTestimonials] = useState(initialData?.data || []);

  const handleClick = async () => {
    const res = await getTestimonials({
      ...params,
      limit: pagination?.limit,
      start: pagination.start,
    });
    if (res) {
      setPagination((prev) => ({
        ...prev,
        start: prev.start + prev.limit,
        total: res?.meta?.pagination.total,
      }));
      setTestimonials([...testimonials, ...flattenAttributes(res?.data || [])]);
    }
  };

  return (
    <>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-9 items-center">
        {testimonials.map((testimonial, index) => (
          <div className="relative" key={index}>
            <div className="right-0 top-0 absolute w-[80px] h-[70px] 2xl:w-[90px] 2xl:h-[70px] overflow-hidden z-[21]">
              <Image
                loading="lazy"
                src={reviewIcon.src}
                fill
                objectFit="contain"
                className="w-full h-full"
                alt="Image"
                width=""
                height=""
              />
            </div>
            <RoundShape />
            <ProfileCard
              key={index}
              image={getImageUrlNew(testimonial?.image, "medium")}
              name={testimonial?.fullname}
              title={testimonial?.designation}
              description={testimonial?.comment}
            />
          </div>
        ))}
      </div>
      {pagination?.total > testimonials?.length && (
        <SecondaryOuter className="mt-10 lg:mt-0 mx-auto" onClick={handleClick}>
          {dict.loadMore}
        </SecondaryOuter>
      )}
    </>
  );
};

export default TestimonialGrid;
